import { removeNullValues } from '@utils/utils';
import { CompanyWorker } from './company';

export interface CompanyWorkerVM
  extends Omit<CompanyWorker, 'occupationId' | 'occupationName'> {
  occupation?: { id: number; name: string };
}

export const toContactDTO = (contact: CompanyWorkerVM, companyId: number) => {
  const obj = removeNullValues(contact);
  const occupation = { ...obj.occupation };
  delete obj.occupation;
  const result: CompanyWorker = {
    ...obj,
    occupationId: occupation?.id,
    occupationName: occupation?.name,
    companyId,
  };

  return result;
};
